import React from "react";
import ReactDOM from "react-dom";
import "@less/registration.less";
import { BaseDashboardComponent } from "@components/BaseDashboardComponent";
import { FreeTrialRegistration } from "@scenes/FreeTrial";

const App = () => {
  return (
    <BaseDashboardComponent>
      <FreeTrialRegistration />
    </BaseDashboardComponent>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
